import { AlertTriangle } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';

export interface WarningProps {
  /** Message HTML. */
  messageWarning: string;
}

const Warning = ({ messageWarning }: WarningProps) => {
  return (
    <Alert variant="warning" className="mb-6">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription>
        <span dangerouslySetInnerHTML={{ __html: messageWarning }} />
      </AlertDescription>
    </Alert>
  );
};

export default Warning;
